<script>
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';

  export default {
    name: 'ConductInspectionItemQuestionInstruction',
    components: {
      ImageAsset,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<template>
  <ImageAsset v-if="item.params.image_id || item.params.image" :photo="item.params" />
</template>
